import React, { Component } from 'react';

import AdminLayout from './layout';

import AllReports from './All_reports';

import {adminDashboard,  CSPExport, DAFExport, WishExport, RatingExport  } from '../../API/FetchCall';

import { Chart } from 'chart.js';

import Tabs from "./Tabs";
import TabsPane from "./Tabs/TabsPane";

const doughnutPieOptions = {
          responsive: true,
          animation: {
            animateScale: true,
            animateRotate: true
          }
        };    

const childTabs = [
  {
    name: "All Reports",
    id: "all_reports",
    defaultChecked: true,
  }
];

class reports extends Component {

    constructor(props) {
        super(props);
        this.state = {
          school_data: []
        };
    }

    componentDidMount() {

   let req = {
      url: 'service_provider_report'
    };
    adminDashboard(JSON.stringify(req)).then(response => {
      if (response.status === 1) {
        //this.datatabledata(response.result);
      }
    });
    req.url = 'wishlist_report';
    adminDashboard(JSON.stringify(req)).then(response => {
      if (response.status === 1) {
        //this.datatableenqdata2(response.result);
      }
    });

    req.url = 'device_report';
    adminDashboard(JSON.stringify(req)).then(response => {
      if (response.status === 1) {
        //this.datatableenqdata(response.result);
      }

    });

    req.url = 'rating_report';
    adminDashboard(JSON.stringify(req)).then(response => {
      if (response.status === 1) {
        console.log('response', response)
        let rating = [...response.school, ...response.preschool, ...response.playarea, ...response.hobbies, ...response.event, ...response.camp, ...response.tutions, ...response.advice]

        console.log('response', rating)
        //this.datatableenqdata3(rating);
      }
    });    
           


    }


  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh')
    // jQuery("#currency_selected").val(4);
  }

 exportCSPExcel = (e) => {
    this.CSPExport()

  }

  CSPExport = async () => {
    try {
      const res = await CSPExport();
      if (res.status === 1) {
        window.open(res.path);
        // window.location.href(res.path)
      }
    } catch (error) {
      this.setState({ error: true });
    }
  };




  exportDAFExcel = (e) => {
    this.DAFExport()

  }

  DAFExport = async () => {
    try {
      const res = await DAFExport();
      if (res.status === 1) {
        window.open(res.path);
        // window.location.href(res.path)
      }
    } catch (error) {
      this.setState({ error: true });
    }
  };



  exportWishExcel = (e) => {
    this.WishExport()

  }

  WishExport = async () => {
    try {
      const res = await WishExport();
      if (res.status === 1) {
        window.open(res.path);
        // window.location.href(res.path)
      }
    } catch (error) {
      this.setState({ error: true });
    }
  };

  exportRatingExcel = (e) => {
    this.RatingExport()

  }

  RatingExport = async () => {
    try {
      const res = await RatingExport();
      if (res.status === 1) {
        window.open(res.path);
        // window.location.href(res.path)
      }
    } catch (error) {
      this.setState({ error: true });
    }
  };    


    setAfterschoolChart = (data) => {

        var ctx = document.getElementById('afterschoolChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }    

    setTuitionChart = (data) => {

        var ctx = document.getElementById('tuitionChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setSchoolChart = (data) => {

        var ctx = document.getElementById('schoolChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setPreschoolChart = (data) => {

        var ctx = document.getElementById('preschoolChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    } 


    setcampChart = (data) => {

        var ctx = document.getElementById('campChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setcommunityChart = (data) => {

        var ctx = document.getElementById('communityChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setbirthdayChart = (data) => {

        var ctx = document.getElementById('birthdayChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }        


    render() {

        return (
            <React.Fragment>
                <AdminLayout>
                    
                        <div class="row  mt-3">
                            <div class="col-xl-12 d-flex grid-margin stretch-card">
                              <div class="card">
                                <div class="card-body">
                                  <div class="d-flex flex-wrap justify-content-between">
                                    <h4 class="card-title mb-3">Reports</h4>
                                  </div>
                                  <div class="row">
                                    <div class="col-12">
                                       
                                         <div className="tab-content">
                                          <Tabs tabsetName="Comments" childTabs={childTabs}>
                                            <TabsPane id="all_reports">
                                              <AllReports />
                                            </TabsPane>
                                           </Tabs>
                                         </div>


                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
  
                        </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default reports;


// WEBPACK FOOTER //
// ./src/components/bewise/reports.jsx